import React, { FC, memo, ReactNode, useCallback, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { TabSwitcher } from 'shared/ui/TabSwitcher';
import { WaitingListTable } from './WaitingListTable';
import { TableFilterContextProvider } from 'features/TableFilter';
import { ChooseUserModal } from 'widgets/ChooseUserModal';
import { WaitingListEntryDrawer } from 'widgets/WaitingListEntryDrawer';

export const WaitingListPage: FC = memo(() => {
  const [selectedTabKey, setSelectedTabKey] = useState('incompleted');

  const { t } = useAppTranslation('contracts');

  const switchTab = useCallback((tabKey: string): void => {
    setSelectedTabKey(tabKey);
  }, []);

  const renderTabContent = useCallback((): Nullable<ReactNode> => {
    switch (selectedTabKey) {
      case 'completed':
        return <WaitingListTable isCompleted={true} />;
      default:
        return <WaitingListTable isCompleted={false} />;
    }
  }, [selectedTabKey]);

  const tabs = [
    { key: 'incompleted', label: t('Incompleted') },
    { key: 'completed', label: t('Completed') },
  ];

  return (
    <>
      <TabSwitcher className="mt-7" tabs={tabs} selectedTabKey={selectedTabKey} onChangeTab={switchTab}>
        <TableFilterContextProvider>{renderTabContent()}</TableFilterContextProvider>
      </TabSwitcher>
      <WaitingListEntryDrawer />
      <ChooseUserModal />
    </>
  );
});
